<template>
	<button :name="name">
		<svgicon name="arrow" :class="direction"></svgicon>
	</button>
</template>
<script>
import '../icons/arrow';
export default {
	props: {
		direction: {
			type: String,
			default: 'right'
		},
		name: {
			type: String,
			required: true
		}
	}
};
</script>
<style lang="scss" scoped>
button {
	height: 24px;
	width: 48px;
	background-color: #ffffff;
	border: 2px solid $button-border;
	border-radius: 12px;
	outline: 0;

	@media (min-width: $breakpoint-mid) {
		height: 32px;
		width: 54px;
		border-radius: 16px;
	}

	&:not(:disabled) {
		&:hover {
			cursor: pointer;
		}
		svg:hover {
			fill: $hover-state;
		}
	}

	&:disabled {
		svg {
			fill: $disabled-state;
		}
	}

	svg {
		fill: $primary-state;

		&.left {
			transform: rotate(180deg);
		}

		@media (min-width: $breakpoint-mid) {
			height: 16px;
			width: 24px;
		}
	}
}
</style>
